import { render } from "./TraqrAddStep.vue?vue&type=template&id=3d52e6d7&lang=html"
import script from "./TraqrAddStep.vue?vue&type=script&lang=js"
export * from "./TraqrAddStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__